import { createReducer, on } from '@ngrx/store';
import { TravelCounsellorsList } from 'src/app/shared/models/TravelCounsellorsList';
import * as TravelCounsellorsActions from '../actions/travel-counsellors.actions';

export interface TravelCounsellorsState {
  list: TravelCounsellorsList;
  loading: boolean;
  error: Error;
}

export const initialState: TravelCounsellorsState = {
  list: undefined,
  loading: false,
  error: undefined,
};

export const reducer = createReducer(
  initialState,
  on(TravelCounsellorsActions.setTravelCounsellors, (state, action) => ({
    ...state,
    list: action.list,
  })),
  on(TravelCounsellorsActions.clearTravelCounsellorsState, () => ({
    ...initialState,
  })),
);
